.bpm-spinner-trace {
  fill: none;
  stroke: currentColor;
  stroke-linejoin: round;
  stroke-linecap: round;
  stroke-dasharray: .23 .77;
  animation: bpm-spinner-travel 4.2s linear infinite;
}

@keyframes bpm-spinner-travel {
  0% { stroke-dashoffset: 0; }
  1.98987% { stroke-dashoffset: -0.0328280; }
  11.48573% { stroke-dashoffset: -0.1198605; }
  21.37144% { stroke-dashoffset: -0.2104660; }
  23.12994% { stroke-dashoffset: -0.2394768; }
  33.03913% { stroke-dashoffset: -0.3302976; }
  42.53499% { stroke-dashoffset: -0.4173300; }
  44.52487% { stroke-dashoffset: -0.4501581; }
  59.51833% { stroke-dashoffset: -0.5875777; }
  62.34117% { stroke-dashoffset: -0.6341477; }
  72.27450% { stroke-dashoffset: -0.7251896; }
  82.18369% { stroke-dashoffset: -0.8160104; }
  85.00654% { stroke-dashoffset: -0.8625804; }
  100% { stroke-dashoffset: -1; }
}

@media (prefers-reduced-motion: reduce) {
  .bpm-spinner-trace { animation: none; }
}
